import { isNil, size, split, toUpper } from 'lodash'

import { formatDescriptorOriginField } from '../../common/utils'

const computeLabelOccurenceOriginField = occurrence => {
  if (isNil(occurrence.menuTitleId)) {
    return occurrence.originField
  }

  const fragments = split(occurrence.originField, ':')
  const fieldName = fragments[0]
  const prefix = `menuTitle${toUpper(fieldName[0])}${fieldName?.substring(
    1,
    size(fieldName),
  )}:${occurrence.menuTitleId}`

  if (size(fragments) > 1) {
    return formatDescriptorOriginField(prefix, fragments[2], fragments[1])
  }

  return prefix
}

export default computeLabelOccurenceOriginField
